module.exports = __webpack_public_path__ + "img/question.bdce9dcd.png";